import { useState, useCallback, useRef } from 'react';

type UseScrollSpyReturn = {
  activeId: string;
  onInView: (id: string, inView: boolean) => void;
};

export const useScrollSpy = (initialId: string): UseScrollSpyReturn => {
  const [activeId, setActiveId] = useState<string>(initialId);
  const visibleIdsRef = useRef<Set<string>>(new Set());

  const onInView = useCallback((id: string, inView: boolean) => {
    if (inView) {
      visibleIdsRef.current.add(id);
    } else {
      visibleIdsRef.current.delete(id);
    }

    if (visibleIdsRef.current.size === 0) return;

    let topId = '';
    let topPosition = Infinity;

    visibleIdsRef.current.forEach((visibleId) => {
      const el = document.getElementById(visibleId);
      if (!el) return;

      const top = el.getBoundingClientRect().top;
      if (top < topPosition) {
        topPosition = top;
        topId = visibleId;
      }
    });

    if (topId) setActiveId(topId);
  }, []);

  return { activeId, onInView };
};
